import React from 'react';
import { connect } from "react-redux";
import * as Constants from '../../Constants';
import { pageChangeWithNoStateChange, pageChange } from '../../action/view';
import { Link } from "react-router-dom";

function mapStateToProps(state) {
    return state;
}

const mapDispatchToProps = {
    pageChange,
    pageChangeWithNoStateChange
};
class AddSuccess extends React.Component {
    returnToWorkplans(e){
        this.props.pageChange(Constants.WORKPLANS);
    }

    editWorkplanButton(e){
        this.props.pageChangeWithNoStateChange(Constants.WORKPLANS);
    }

    render() {
        return (
            <div className="add-user-div normal-box float-left">
                <div className="add-user normal-margin center">
                    <img alt="Pistive Vote" src="/img/positive-vote.svg" className="postive-vote"></img>
                    <p>{this.props.workplanView.message ? this.props.workplanView.message: ""}</p>
                    <Link to="/workplans" className="white-red-button" onClick={this.editWorkplanButton.bind(this)}>Edit Program</Link>
                    <br/>
                    <Link to="/workplans" onClick={this.returnToWorkplans.bind(this)}><img src="/img/arrow-left-red.svg" alt="Arrow Left" className="arrow"></img>Return to Program</Link>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddSuccess);
